import axiosConfig from '../axiosConfig';
import { TSystemUser } from '../systemUser/SystemUser';

export type TActivityLog = {
	id: number;
	activity_type: string;
	message: string;
	entity_id: number;
	entity_type: string;
	created_at: number;
	initiator_id: number;
	ip_address: string;
	context: string;
	user?: TSystemUser;
};

export class ActivityLog implements TActivityLog {
	id: number;
	activity_type: string;
	message: string;
	entity_id: number;
	entity_type: string;
	created_at: number;
	initiator_id: number;
	ip_address: string;
	context: string;
	user?: TSystemUser;

	public static Default(): TActivityLog {
		return {
			id: 0,
			activity_type: '',
			message: '',
			entity_id: 0,
			entity_type: '',
			created_at: 0,
			initiator_id: 0,
			ip_address: '',
			context: '',
		};
	}

	constructor(entity: TActivityLog) {
		this.id = entity.id;
		this.activity_type = entity.activity_type;
		this.message = entity.message;
		this.entity_type = entity.entity_type;
		this.entity_id = entity.entity_id;
		this.created_at = entity.created_at;
		this.initiator_id = entity.initiator_id;
		this.ip_address = entity.ip_address;
		this.context = entity.context;
	}

	public static GetAll(expand: (keyof TActivityLog)[] = []): Promise<TActivityLog[]> {
		return axiosConfig.instance
			.get('admin/activity-log', { params: { expand: expand } })
			.then((res) => {
				return (res.data as TActivityLog[]).map((entity: TActivityLog) => {
					return entity;
				});
			});
	}
}
